module.exports = __webpack_public_path__ + "static/img/channel.11.1902aad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channel.11.png
// module id = 220
// module chunks = 138 379 380